import { Color, Quaternion, Vector3 } from "flavr-math";
import { Renderable } from "../renderable/Renderable";
const tempVector3_1 = new Vector3();
const tempVector3_2 = new Vector3();
const tempQuaternion_1 = new Quaternion();
const tempColor = new Color();
export class TruncatedConeRenderable extends Renderable {
    constructor(owner) {
        super(owner);
        this.type = TruncatedConeRenderable.typestatic;
    }
    destroy() {
        if (this.instance === undefined)
            return;
        this.instance.destroy();
        this.instance = undefined;
        if (this.facet && this.facet.material && this.facet.material.castShadow) {
            this.owner.renderer.updateShadowForModel(this.owner.modelUID);
        }
    }
    getGeometry() {
        if (!this.instance)
            return undefined;
        return {
            geometry: this.instance.geometry
        };
    }
    setVisible(visible) {
        if (this.instance === undefined) {
            throw new Error("We expect this.instance to be defined.");
        }
        this.instance.setVisible(visible);
        if (this.facet && this.facet.material && this.facet.material.castShadow) {
            this.owner.renderer.updateShadowForModel(this.owner.modelUID);
        }
    }
    updateFacet(facet) {
        if (!this.facet || this.facet.material !== facet.material) {
            if (this.instance)
                this.instance.destroy();
            this.instance = this.owner.renderer.createInstancedTruncatedCone(this.owner.modelUID, facet.material);
            this.instance.setPosition(this.owner.worldPosition);
            this.instance.setOrientation(this.owner.worldOrientation);
            this.instance.setScale(this.owner.worldScale);
            if (this.facet && this.facet.material.castShadow) {
                this.owner.renderer.updateShadowForModel(this.owner.modelUID);
            }
        }
        if (this.instance) {
            this.instance.setColor(tempColor.set(facet.color));
            this.instance.setShape(facet.ratio, facet.pointUp);
        }
    }
    updateTransform() {
        if (this.instance === undefined) {
            throw new Error("We expect this.instance to be defined.");
        }
        const position = tempVector3_1;
        const orientation = tempQuaternion_1;
        const scale = tempVector3_2;
        this.owner.getWorldTransform(position, orientation, scale);
        this.instance.setPosition(position);
        this.instance.setOrientation(orientation);
        this.instance.setScale(scale);
        if (this.facet && this.facet.material && this.facet.material.castShadow) {
            this.owner.renderer.updateShadowForModel(this.owner.modelUID);
        }
    }
}
TruncatedConeRenderable.typestatic = "TruncatedCone";
